import Repository from "../Repository";

const resource = "/product/corset";

export default {
  /**
   * Get corset product
   * @param {*} corset_uuid
   */
  async get(corset_uuid) {
    return Repository.get(`${resource}/${corset_uuid}`);
  },

  async createCorset(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
